import { useWindowDimensions, Platform } from 'react-native';

const DESKTOP_BREAKPOINT = 768;

/**
 * Returns true when on web with a viewport >= 768px wide.
 * On native, always returns false. Reactively updates on resize.
 */
export function useIsDesktop(): boolean {
  const { width } = useWindowDimensions();
  if (Platform.OS !== 'web') return false;
  return width >= DESKTOP_BREAKPOINT;
}
